import { textFilter } from "react-bootstrap-table2-filter";
import {
  getCellStyle,
  GetHeaderStyle,
  Post,
  PostJson,
} from "../../core/Helper";
import { encode } from "js-base64";

export class WebSearchHelperService {
  static async GetList(params) {
    let result = await Post("api/web-search-helper/get-data", params);
    return result ?? null;
  }

  static async Query(sql, text, root, userDetail) {
    return await WebSearchHelperService.GetBasicReport(
      {
        text: text ?? "",
        root: root ?? "",
        sql: encode(sql),
      },
      userDetail,
    );
  }

  static async GetBasicReport(data, user) {
    let result = await PostJson("api/report/basic-report", { data, user });
    return result ?? null;
  }

  static SearchA_Physician = (props) => {
    const [setSearhStateA, searchStateA, dataX, userDetail] = props;

    setSearhStateA({
      ...searchStateA,

      show: true,
      headerText: "แพทย์เจ้าของไข้",
      sql: {
        fields: [
          "a.staffid itemId",
          "concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
        ],
        tableName:
          " ba_staff a " +
          "inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n' " +
          "inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria:
          "b.flag_physician='y' and a.del_flag='n' and brchid=" +
          userDetail.brchid,
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 3000,
      },
      action: (data) => {
        dataX.studyInfo.physician_staffid = data.itemId;
        dataX.studyInfo.physician_staff_name = data.itemName;
        setSearhStateA({ show: false });
      },
    });
  };

  static SearchA_RadiConfirmed = (props) => {
    const [setSearhStateA, dataX] = props;

    setSearhStateA({
      show: true,
      headerText: "รังสีแพทย์",
      sql: {
        fields: [
          "a.staffid itemId",
          "concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
        ],
        tableName:
          " ba_staff a " +
          " inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n'  " +
          // " and flag_radi_dummy='`${showEditor?.isOldStudy === true ? "y" : "n"}`   "' " +
          " inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria: "b.flag_radi='y' and a.del_flag='n' ",
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 3000,
      },
      setDefaultValue: (data) => {
        dataX.studyInfo.radi_staffid = data.itemId;
        dataX.studyInfo.radi_staff_name = data.itemName;
      },
      action: (data) => {
        // event return from "Search"
        dataX.studyInfo.radi_staffid = data.itemId;
        dataX.studyInfo.radi_staff_name = data.itemName;
        setSearhStateA({ show: false });
      },
    });
  };

  static SearchB_AllStaffType = (props) => {
    const [setSearchB, data] = props;
    setSearchB({
      show: true,
      size: "lg", //*
      fieldId: "staffid", //*
      fieldName: "itemName", //*
      sql: {
        fields: [
          "a.staffid itemId",
          "a.staffcode itemCode",
          " concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
          "b.stafftypeshort itemShort",
        ],
        tableName:
          " ba_staff a " +
          "inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n' and b.flag_radi_dummy='n' " +
          "inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria: " a.del_flag='n'",
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 3000,
      },
      action: (item) => {
        if (data) {
          data.staffid = item?.itemId;
          data.staff_fullname = item?.itemName;
          if (!data.username) {
            data.username = item?.itemCode;
          }
          setSearchB((pv) => ({ ...pv, show: false }));
        }
      },
      columns: [
        {
          dataField: "itemCode",
          text: "รหัสพนักงาน",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemName",
          text: "ชื่อ-สกุล",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemShort",
          text: "แผนก",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
      ],
    });
  };
  static SearchB_AllBranchPacs = (props) => {
    const [setSearchB, data, setData] = props;
    setSearchB({
      show: true,
      size: "lg",
      fieldId: "itemId",
      fieldName: "itemName",
      sql: {
        fields: [
          "a.brchid itemId, a.brchcode itemCode , brchshort itemName, compshort ",
        ],
        tableName:
          " ba_branch a " +
          " inner join ba_company b on a.compid = b.compid and a.del_flag='n' ",
        defaultCriteria: " a.del_flag='n'",
        criteriaFields: ["a.brchshort"],
        criteriaText: "",
        orderBy: ["a.brchshort"],
        maxRows: 5000,
      },
      action: (item) => {
        if (data) {
          setData((pv) => ({
            ...pv,
            ...{ brchid: item.itemId, brchshort: item.itemName },
          }));
          setSearchB((pv) => ({ ...pv, show: false }));
        }
      },
      columns: [
        {
          dataField: "itemCode",
          text: "รหัสสาขา",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemName",
          text: "ชื่อสาขา",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "compshort",
          text: "สังกัด",
          sort: true,
          headerStyle: GetHeaderStyle("120px", "center"),
          style: getCellStyle("center", "var(--table-text-color)"),
          filter: textFilter({ placeholder: "..." }),
        },
      ],
    });
  };

  static SearchB_AllStaff = (props) => {
    const [setSearchB, data] = props;
    setSearchB({
      show: true,
      size: "lg", //*
      fieldId: "staffid", //*
      fieldName: "itemName", //*
      sql: {
        fields: [
          "a.staffid itemId",
          "a.staffcode itemCode",
          " concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
          "b.stafftypeshort itemShort",
        ],
        tableName:
          " ba_staff a " +
          "inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n' and b.flag_radi_dummy='n' " +
          "inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria: " a.del_flag='n'",
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 5000,
      },
      action: (item) => {
        if (data) {
          data.staffid = item?.itemId;
          data.staff_fullname = item?.itemName;
          if (!data.username) {
            data.username = item?.itemCode;
          }
          setSearchB((pv) => ({ ...pv, show: false }));
        }
      },
      columns: [
        {
          dataField: "itemCode",
          text: "รหัสพนักงาน",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemName",
          text: "ชื่อ-สกุล",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemShort",
          text: "แผนก",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
      ],
    });
  };

  static SearchB_AllBranch = (props) => {
    const [setSearchB, data, setData] = props;
    setSearchB({
      show: true,
      size: "lg",
      fieldId: "itemId",
      fieldName: "itemName",
      sql: {
        fields: [
          "a.brchid itemId, a.brchcode itemCode , brchshort itemName, compshort ",
        ],
        tableName:
          " ba_branch a " +
          " inner join ba_company b on a.compid = b.compid and a.del_flag='n' ",
        defaultCriteria: " a.del_flag='n'",
        criteriaFields: ["a.brchshort"],
        criteriaText: "",
        orderBy: ["a.brchshort"],
        maxRows: 3000,
      },
      action: (item) => {
        if (data) {
          setData((pv) => ({
            ...pv,
            ...{ brchid: item.itemId, brchshort: item.itemName },
          }));
          setSearchB((pv) => ({ ...pv, show: false }));
        }
      },
      columns: [
        {
          dataField: "itemCode",
          text: "รหัสสาขา",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemName",
          text: "ชื่อสาขา",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "compshort",
          text: "สังกัด",
          sort: true,
          headerStyle: GetHeaderStyle("120px", "center"),
          style: getCellStyle("center", "var(--table-text-color)"),
          filter: textFilter({ placeholder: "..." }),
        },
      ],
    });
  };

  static SearchB_BranchCustomer = (props) => {
    const [setSearchB, data, setData] = props;
    setSearchB({
      show: true,
      size: "lg",
      fieldId: "itemId",
      fieldName: "itemName",
      sql: {
        fields: ["a.custid itemId, a.custcode itemCode , cust_short itemName "],
        tableName: " brch_customer a ",
        defaultCriteria: " a.del_flag='n' and brchid = " + data?.brchid ?? 0,
        criteriaFields: ["a.cust_short"],
        criteriaText: "",
        orderBy: ["a.cust_short"],
        maxRows: 3000,
      },
      action: (item) => {
        if (data) {
          setData((pv) => ({
            ...pv,
            ...{ custid: item.itemId, custshort: item.itemName },
          }));
          setSearchB((pv) => ({ ...pv, show: false }));
        }
      },
      columns: [
        {
          dataField: "itemCode",
          text: "รหัส",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "itemName",
          text: "ชื่อหน่วยงาน",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
      ],
    });
  };
}
